import { computed, makeObservable } from 'mobx'

import { ModelWithPolicy } from 'modules/core/lib/modelWithPolicy'
import users from 'modules/core/store/collections/users'
import type User from 'modules/core/store/models/User'
import GoalPolicy from 'modules/core/store/models/policies/GoalPolicy'

export const PROGRESS_STATUS = {
  achieved: 'achieved',
  onTrack: 'on_track',
  atRisk: 'at_risk',
  progressing: 'progressing',
  overAchieved: 'over_achieved',
  notAchieved: 'not_achieved',
}
interface Metadata {
  current_value_in_cents: string
  goal_value_in_cents: string
  goal_progress: number
  id: number
}

interface IGoal {
  [key: string]: any
}

class Goal extends ModelWithPolicy<IGoal> {
  constructor(attr: IGoal = {}) {
    super(attr)
    makeObservable(this, {
      user: computed,
      metadata: computed,
    })
  }

  static urlRoot() {
    return '/goals/goals'
  }

  get policy() {
    return new GoalPolicy(this)
  }

  get user(): User | null | undefined {
    return users.find({
      id: this.attributes.owner_id,
    })
  }

  get metadata(): Metadata {
    return this.attributes.metadata
  }
}

export default Goal
